'use strict';
import React, { PureComponent } from 'react';
import IndicadoresInterfaz from './IndicadoresInterfaz';


class IndicadorInterfazBuscador extends PureComponent {
    constructor(props) {
        super(props);
    
        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarIndicadoresInterfaz = this.buscarIndicadoresInterfaz.bind(this);
        this.mostrarResultados = this.mostrarResultados.bind(this);
    }

    mostrarResultados() {
        this.props.mostrarOcultarResultadosIndicadorInterfaz(true);
    }

    buscarIndicadoresInterfaz(event) {
        let valorInput = event.target.value;

        this.props.buscarIndicadoresInterfaz(valorInput);
    }

    limpiarBusqueda() {
        this.props.buscarIndicadoresInterfaz("", "", true, null);
    }

    onKeyPress(event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    render() {
        const {
            descripcionIndicadorInterfazSeleccionado,
            inputIndicadorInterfaz,
            indicadorInterfazFiltrados,
            indicadorInterfazSeleccionado,
            mostrarResultadosIndicadorInterfaz,
            puedeModificar
        } = this.props;

        //ACTIONS
        const { 
            buscarIndicadoresInterfaz
        } = this.props;

        let arrayIndicadoresInterfaz = [];


        indicadorInterfazFiltrados && indicadorInterfazFiltrados.map(indicador => {
            arrayIndicadoresInterfaz.push(<IndicadoresInterfaz
                                                  buscarIndicadoresInterfaz={buscarIndicadoresInterfaz}
                                                  indicador={indicador}
                                                  key={indicador.Id}
                                          />);
        });

        arrayIndicadoresInterfaz = arrayIndicadoresInterfaz.length == 0 ? 
                                        <div className="ABMModelos__opcionBuscadorCuentasContablesSinResultados">No se encontraron resultados</div>
                                    : 
                                        arrayIndicadoresInterfaz;

        return (
            <div className="ABMModelosModalContainer__contenedorBuscadorReemplazarCuentas">
                <div>
                    <div className="col-md-12 seccionSuperior__buscador ABMModelosModalContainer__buscadorMargen ABMModelos__contenedorBuscadorImportarModelos">
                        {!indicadorInterfazSeleccionado ? 
                            <div className="AsientosContables--floatLeft seccionSuperior__iconoLupa ABMModelosModalContainer__iconoLupaInput"></div>
                        :
                            null
                        }

                        <div className="AsientosContables--floatLeft">
                            <input
                                className={"textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs seccionSuperior__inputBuscador ABMModelosModalContainer__buscadorAncho" + (indicadorInterfazSeleccionado ? " ABMModelos__buscadorCuentasContables--valorSeleccionado" : "")}
                                id={"buscadorIndicadorInterfaz"}
                                disabled={puedeModificar ? indicadorInterfazSeleccionado : true}
                                name={"buscadorIndicadorInterfaz"}
                                onChange={puedeModificar ? indicadorInterfazSeleccionado ? null : this.buscarIndicadoresInterfaz : null}
                                onClick={puedeModificar ? indicadorInterfazSeleccionado ? null : this.mostrarResultados : null}
                                onKeyDown={null}
                                onKeyPress={puedeModificar ? indicadorInterfazSeleccionado ? null : this.onKeyPress : null}
                                placeholder="Buscar por código o valor de indicador"
                                value={indicadorInterfazSeleccionado ? descripcionIndicadorInterfazSeleccionado : inputIndicadorInterfaz}
                            />
                        </div>


                        {puedeModificar ?
                            (inputIndicadorInterfaz && inputIndicadorInterfaz.length > 0) || indicadorInterfazSeleccionado ?
                                <div className="seccionSuperior__botonBuscador ABMModelosModalContainer__buscadorBotonBorrarBusqueda ABMModelos__contenedorBuscadorImportarModelos__botonLimpiar">
                                    <button type="button" className="btn-tag seccionSuperior__botonBorrarBusqueda"
                                        onClick={this.limpiarBusqueda}>
                                        <span className="ti-close span-closable" />
                                    </button>
                                </div>
                            :
                                null
                        :
                            null
                        }
                    </div>

                    <div className={"ABMModelos__contenedorBuscadorImportarModelosBotones AsientosContables--overflowHidden ABMModelos__opcionBuscadorIndicadorInterfaz slider-tarjetas" + (mostrarResultadosIndicadorInterfaz ? "" : " closed")}>
                        <div className="modalLogIntentosScroll ABMModelos__ContenedorOpcionesBuscadorImportarModelos">
                            {arrayIndicadoresInterfaz}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default IndicadorInterfazBuscador;